import { render, staticRenderFns } from "./AdminConfigs.vue?vue&type=template&id=d15f2f40&scoped=true&"
import script from "./AdminConfigs.vue?vue&type=script&lang=js&"
export * from "./AdminConfigs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d15f2f40",
  null
  
)

export default component.exports